const state = {
  // astRequestId: null,
};

const mutations = {
  // DELETE_AST_REQUEST_ID: (state) => {
  //   state.astRequestId = null;
  // },
};

const actions = {
  // getRequestReminds({ commit }) {
  //   const setRemindOptions = (options) => commit('SET_REMIND_OPTIONS', options);
  //   return getRequestReminds().then(setRemindOptions);
  // },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
